<template>
  <AuthContainer>
    <div class="text-center mb-8">
      <!--  <div class="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
        <svg class="w-8 h-8 text-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </div> -->

      <h1 class="text-3xl md:text-4xl font-semibold mb-4">
        {{ $t('auth.verifyEmail.title') }}
      </h1>
      <p class="text-gray-700 text-lg mb-2">
        {{ $t('auth.verifyEmail.subtitle') }}
      </p>
      <p class="text-gray-600 text-base font-medium">
        {{ userEmail }}
      </p>
    </div>

    <div class="space-y-6">
      <!-- Instructions -->
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 class="font-semibold text-gray-700 mb-2">
          {{ $t('auth.verifyEmail.instructions.title') }}
        </h3>
        <ol class="text-sm text-gray-700 space-y-2 list-decimal list-inside">
          <li>{{ $t('auth.verifyEmail.instructions.step1') }}</li>
          <li>{{ $t('auth.verifyEmail.instructions.step2') }}</li>
          <li>{{ $t('auth.verifyEmail.instructions.step3') }}</li>
        </ol>
      </div>

      <div v-if="resendError" class="p-3 bg-red-50 border border-red-200 rounded-md">
        <p class="text-sm text-red-600 text-center">
          {{ $t('auth.verifyEmail.resendError') }}
        </p>
      </div>

      <div v-if="resendSuccess" class="p-3 bg-green-50 border border-green-200 rounded-md">
        <p class="text-sm text-green-600 text-center">
          {{ $t('auth.verifyEmail.resendSuccess') }}
        </p>
      </div>

      <div class="text-center">
        <p class="text-sm text-gray-600 mb-3">
          {{ $t('auth.verifyEmail.didntReceive') }}
        </p>
        <BaseButton
          @click="resendVerificationEmail"
          :loading="isResending"
          :disabled="isResending || countdown > 0"
          width="w-full"
        >
          {{
            countdown > 0
              ? $t('auth.verifyEmail.resendIn', { seconds: countdown })
              : isResending
                ? $t('auth.verifyEmail.resending')
                : $t('auth.verifyEmail.resend')
          }}
        </BaseButton>
      </div>

      <div class="text-center text-sm text-gray-500">
        <p>{{ $t('auth.verifyEmail.checkSpam') }}</p>
      </div>
    </div>

    <router-link
      append
      class="hover:text-main-hover cursor-pointer font-medium transition-colors mt-8 md:mt-12 2xl:mt-14 text-center text-md block"
      :to="{ name: RoutesKey.AUTH_SIGN_IN }"
    >
      {{ $t('auth.verifyEmail.returnToSignIn') }}
    </router-link>
  </AuthContainer>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import BaseButton from '@/components/ui/BaseButton.vue'
import { RoutesKey } from '@/models/enums/app/RoutesKey'
import AuthContainer from './AuthContainer.vue'
import { AuthenticationService } from '@/services/userAndAuth/AuthenticationService'

const route = useRoute()

const userEmail = ref((route.query.email as string) || '')

const isResending = ref(false)
const resendError = ref(false)
const resendSuccess = ref(false)
const countdown = ref(0)
let countdownInterval: number | null = null

const startCountdown = () => {
  countdown.value = 60
  countdownInterval = window.setInterval(() => {
    countdown.value--
    if (countdown.value <= 0 && countdownInterval) {
      clearInterval(countdownInterval)
      countdownInterval = null
    }
  }, 1000)
}

const resendVerificationEmail = async () => {
  try {
    isResending.value = true
    resendError.value = false
    resendSuccess.value = false

    await AuthenticationService.resendEmailVerifier(userEmail.value)
    resendSuccess.value = true
    startCountdown()

    setTimeout(() => {
      resendSuccess.value = false
    }, 5000)
  } catch {
    resendError.value = true
  } finally {
    isResending.value = false
  }
}

onUnmounted(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval)
  }
})

onMounted(() => {
  startCountdown()
})
</script>
